import { Link, useLocation } from "react-router-dom";
import { AudioWaveform } from "lucide-react";
import { AFFILIATE_URL } from "../lib/constants";
import { trackCta } from "../lib/tracking";

export const Header = () => {
  const { pathname } = useLocation();
  const linkCls = (active) =>
    `text-sm font-semibold transition-colors duration-200 ${active ? "text-[#1A56DB]" : "text-slate-600 hover:text-slate-900"}`;
  return (
    <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-xl border-b border-slate-200">
      <div className="bg-[#0F172A] text-slate-300 text-[11px] text-center px-4 py-1.5" data-testid="advertiser-disclosure-bar">
        Advertiser Disclosure: Some links on this site are affiliate links — we may earn a commission at no additional cost to you.{" "}
        <Link to="/affiliate-disclosure" data-testid="disclosure-bar-link" className="underline text-slate-200 hover:text-white transition-colors">Learn more</Link>
      </div>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <span className="w-8 h-8 rounded-md bg-[#0F172A] flex items-center justify-center">
            <AudioWaveform className="w-4 h-4 text-white" />
          </span>
          <span className="font-heading font-extrabold text-lg tracking-tight text-[#0F172A]">
            VoiceRanker<span className="text-[#1A56DB]">.ai</span>
          </span>
        </Link>
        <nav className="flex items-center gap-5 sm:gap-8">
          <Link to="/" data-testid="nav-home-link" className={linkCls(pathname === "/")}>Rankings</Link>
          <Link to="/blog" data-testid="nav-blog-link" className={linkCls(pathname.startsWith("/blog"))}>Blog</Link>
          <Link to="/about" data-testid="nav-about-link" className={`hidden sm:block ${linkCls(pathname === "/about")}`}>About</Link>
          <a
            href={AFFILIATE_URL}
            target="_blank"
            rel="nofollow sponsored noopener"
            onClick={() => trackCta("header-nav", AFFILIATE_URL)}
            data-testid="nav-cta-elevenlabs"
            className="hidden md:inline-flex bg-[#1A56DB] text-white hover:bg-[#1547B1] rounded-md px-4 py-2 text-sm font-bold transition-all duration-200 shadow-sm hover:-translate-y-0.5"
          >
            Try #1 Pick Free
          </a>
        </nav>
      </div>
    </header>
  );
};
